import React, { useState } from 'react';

const ModalNumeroRol = ({ isOpen, onClose, onConfirm }) => {
  const [numeroRol, setNumeroRol] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (numeroRol.trim()) {
      onConfirm(numeroRol.trim());
      setNumeroRol('');
    }
  };

  const handleCancel = () => {
    setNumeroRol('');
    onClose();
  };

  const isDisabled = !numeroRol.trim();

  return (
    <div className="reveal-overlay" style={{display: 'block', zIndex: 10000}}>
      <div className="reveal" style={{display: 'block', width: '90%', maxWidth: '30rem'}}>
        <div className="grid-x grid-padding-x">
          <div className="cell">
            <h1>Ingresa el número de rol</h1>
            <form onSubmit={handleSubmit}>
              <label>
                Número de rol:
                <input
                  type="text"
                  value={numeroRol}
                  onChange={(e) => setNumeroRol(e.target.value)}
                  placeholder="Ingrese el número de rol"
                  autoFocus
                />
              </label>
              <div className="button-group" style={{marginTop: '1rem'}}>
                <button
                  type="button"
                  className="button alert"
                  onClick={handleCancel}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="button success"
                  disabled={isDisabled}
                  style={{
                    opacity: isDisabled ? '0.6' : '1',
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                  }}
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalNumeroRol;

